module.exports = __webpack_public_path__ + "img/banner.a1cfc6be.png";